import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { STORAGE_KEYS } from 'utils/constants';
import PageHeaderText from 'components/base/page-header-text';
import axios, { AxiosRequestConfig } from 'axios';
import { apiService } from 'services/base.service';
import CropImageModal from 'components/crop-image-modal';
import { handleApiError } from 'utils/functions';
import { EditAltIcon } from 'cokitchen-icons';

const ProfileHeader = ({
  imgSrc,
  setImgSrc
}: {
  imgSrc?: string | null;
  setImgSrc?: (arg1: string) => void;
}) => {
  const firstName = localStorage.getItem(STORAGE_KEYS.FIRST_NAME);
  const lastName = localStorage.getItem(STORAGE_KEYS.LAST_NAME);
  const imgRef = useRef<HTMLInputElement | null>(null);
  const [uploading, setUploading] = useState(false);

  const [file, setFile] = useState<File | null>(null);
  const [hasUploaded, setHasUploaded] = useState(false);
  const [showCropModal, setShowCropModal] = useState(false);
  const [img, setImg] = useState('');
  const [croppedImage, setCroppedImage] = useState('');
  const [imgType, setImgType] = useState('');
  const [imgName, setImgName] = useState('');

  const token = localStorage.getItem('token');
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };

  const handleButtonClick = () => {
    imgRef?.current?.click();
  };

  const uploadImg = async (imgFile: File) => {
    setUploading(true);
    try {
      const data = new FormData();
      data.append('file', imgFile);
      const res = await axios.post('https://file-api.getfoodcourt.com/upload', data, config);
      if (res?.data) {
        const updateResponse = await apiService.put('user', {
          data: {
            profile_image: res?.data?.url
          }
        });
        if (updateResponse) {
          setHasUploaded(true);
          setImgSrc?.(res?.data?.url);
          //refresh the details
        }
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setUploading(false);
    }
  };

  const onFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    setHasUploaded(false);
    const { files } = e.target;
    if (files) {
      setFile(files[0]);
      setImgType(files[0]?.type);
      setImgName(files[0]?.name);
    }
  };

  const closeCropModal = () => {
    if (!hasUploaded) {
      setFile(null);
      setImg('');
      setCroppedImage('');
      setImgType('');
      setImgName('');
    }
    setShowCropModal(false);
  };
  const convertBlobUrlToBlob = async (blobUrl: string) => {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return blob;
  };

  const blobToFile = (blobData: Blob, fileName: string, mimeType: string) => {
    const file = new File([blobData], fileName, { type: mimeType });
    return file;
  };

  const saveImage = async () => {
    setShowCropModal(false);
    const imageBlob = await convertBlobUrlToBlob(croppedImage);
    const imageFile = blobToFile(imageBlob, imgName, imgType);
    uploadImg(imageFile);
  };

  useEffect(() => {
    if (file) {
      setImg(URL.createObjectURL(file));
      setShowCropModal(true);
    } else {
      if (imgRef.current) imgRef.current.value = '';
    }
  }, [file]);

  return (
    <div>
      {showCropModal && img && (
        <CropImageModal
          show={showCropModal}
          onClose={closeCropModal}
          src={img}
          setCroppedImage={setCroppedImage}
          imgType={imgType}
          saveImage={saveImage}
          circularCrop={true}
        />
      )}
      <PageHeaderText title='Profile' description='Manage your account information' />
      <div className='flex gap-3 items-center'>
        {!imgSrc ? (
          <div className='relative'>
            <div className='font-semibold flex items-center justify-center w-[50px] h-[50px] md:w-[80px] md:h-[80px] text-base sm:text-lg md:text-[32px] rounded-full text-white  bg-red-5'>
              {firstName?.[0]}
              {lastName?.[0]}
            </div>
            <button
              onClick={handleButtonClick}
              disabled={uploading}
              className='absolute bottom-2 right-[-12px] bg-[#FFFFFF] rounded-full  blur-[#888B8F1A]'>
              <EditAltIcon className='m-2' />
            </button>
          </div>
        ) : (
          <div
            className='w-[50px] h-[50px] md:w-[80px] md:h-[80px] rounded-full'
            style={{
              backgroundImage: `url(${imgSrc})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
        )}
        <div className='flex flex-col gap-1'>
          <label className='ml-2 font-medium font-euclid'>
            {firstName} {lastName}
          </label>
          <label className='ml-2  font-euclid text-[#6F7376]'>Mainstore</label>
        </div>
      </div>
      <input ref={imgRef} type='file' hidden accept={'image/*'} onChange={onFileChange} />
    </div>
  );
};

export default ProfileHeader;
